import { Component, Input, OnInit } from '@angular/core';
import { ArticleFactory, ArticleQuery, ArticleService, ArticleSlider, CmsUiArticleSliderContent } from '@lobos/library';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { SwiperOptions } from 'swiper';
import { WeylandSteelArticle } from '../../../../interfaces/steel-article.model';

@Component({
  selector: 'app-ui-article-slider',
  templateUrl: './article-slider.component.html',
  styleUrls: ['./article-slider.component.scss'],
})
export class ArticleSliderComponent implements OnInit {
  @Input() data!: CmsUiArticleSliderContent;

  public articles$: Observable<WeylandSteelArticle[]> | undefined;

  swiperOptions: SwiperOptions | undefined;

  constructor(private articleService: ArticleService<WeylandSteelArticle>, private articleQuery: ArticleQuery<WeylandSteelArticle>) {}

  ngOnInit(): void {
    this.articleService
      .getArticlesByIds(this.data.articleSlider.map((articleSlider: ArticleSlider) => articleSlider.articleNumber))
      .pipe(take(1))
      .subscribe();

    this.articles$ = this.articleQuery
      .selectMany(this.data.articleSlider.map((articleSlider: ArticleSlider) => articleSlider.articleNumber))
      .pipe(
        map(
          (articles: WeylandSteelArticle[]) =>
            articles.map((article: WeylandSteelArticle) => ArticleFactory.create(article)) as WeylandSteelArticle[],
        ),
      );

    this.swiperOptions = {
      speed: 400,
      slidesPerView: 3,
      // slidesPerGroup: 1,
      spaceBetween: 20,
      breakpoints: {
        300: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
      },
    };
  }
}
